"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HighlightsProvider = exports.HighlightsContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _themes = require("../themes");
var _EpubReaderContext = require("./EpubReaderContext");
var _services = require("../services");
var _utils = require("../utils");
var _SideBarContext = require("./SideBarContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } /* eslint-disable no-shadow, no-console */
var HighlightsContext = exports.HighlightsContext = /*#__PURE__*/(0, _react.createContext)();
var HighlightsProvider = _ref => {
  var {
    children
  } = _ref;
  var [highlightsState, setHighlights] = (0, _react.useState)([]);
  var highlights = (0, _react.useRef)(highlightsState);
  var [cfiRange, setCfiRange] = (0, _react.useState)();
  var [contents, setContents] = (0, _react.useState)();
  var [isDraft, setIsDraft] = (0, _react.useState)();
  var {
    setOpenDrawer,
    selectTab,
    setSelectedAnnotation
  } = (0, _react.useContext)(_SideBarContext.SideBarContext);
  var [highlightColor, setHighlightColor] = (0, _react.useState)();
  var [anchorPositionAnnotationPopover, setAnchorPositionAnnotationPopover] = (0, _react.useState)();
  var {
    applicationToken,
    sessionToken,
    uuid,
    userId,
    rendition,
    bookTitle
  } = (0, _react.useContext)(_EpubReaderContext.EpubReaderContext);
  var service = (0, _services.HighlightsService)(applicationToken, sessionToken);
  var appToken = (0, _utils.appTokenCase)(window.location.origin);
  var trackingService = (0, _services.TrackingsService)(appToken, sessionToken);
  (0, _react.useEffect)(() => {
    highlights.current = highlightsState;
  }, [highlightsState]);
  function handleHighlightClose() {
    var _contents$window;
    contents === null || contents === void 0 || (_contents$window = contents.window) === null || _contents$window === void 0 || (_contents$window = _contents$window.getSelection()) === null || _contents$window === void 0 || _contents$window.removeAllRanges();
    setCfiRange();
    setContents();
  }
  function saveHighlight() {
    return _saveHighlight.apply(this, arguments);
  }
  function _saveHighlight() {
    _saveHighlight = _asyncToGenerator(function* () {
      var rend = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rendition;
      var cfiRange = arguments.length > 1 ? arguments[1] : undefined;
      var color = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _themes.DEFAULT_HIGHLIGHT_COLOR;
      var textHighlighted = yield rend.getRange(cfiRange);
      var response = yield service.createUserHighlight({
        book_id: uuid,
        user_id: userId,
        text_reference: cfiRange,
        text_highlighted: textHighlighted.toString(),
        color
      });
      if (response.ok) {
        var {
          data
        } = yield response.json();
        highlights.current.push({
          id: data.id,
          annotation: data.annotation,
          textReference: data.text_reference,
          textHighlighted: data.text_highlighted,
          color
        });
        setHighlights(highlights.current);
        yield trackingService.trackColorHighlight({
          uuid,
          titleCover: bookTitle,
          color,
          id: data.id,
          highlight: textHighlighted.toString()
        });
      }
    });
    return _saveHighlight.apply(this, arguments);
  }
  var replaceHighlightOnState = data => {
    var highlightList = highlights.current.map(highlight => {
      if (data.id === highlight.id) {
        highlight.annotation = data.annotation;
        highlight.color = data.color;
      }
      return highlight;
    });
    setHighlights(highlightList);
  };
  function updateHighlight(_x, _x2) {
    return _updateHighlight.apply(this, arguments);
  }
  function _updateHighlight() {
    _updateHighlight = _asyncToGenerator(function* (highlightId, payload) {
      var response = yield service.updateUserHighlight(highlightId, payload);
      if (!response.ok) {
        // TO DO SEND TO BUGSNAG
      }
      var {
        data
      } = yield response.json();
      return data;
    });
    return _updateHighlight.apply(this, arguments);
  }
  function deleteUserHighlight(_x3) {
    return _deleteUserHighlight.apply(this, arguments);
  }
  function _deleteUserHighlight() {
    _deleteUserHighlight = _asyncToGenerator(function* (highlightId) {
      try {
        var response = yield service.deleteUserHighlight(highlightId);
        if (!response.ok) {
          var errors = yield response.json();
          throw errors;
        }
        var newHighlightList = highlightsState.filter(highlight => highlight.id !== highlightId);
        setHighlights(newHighlightList);
      } catch (error) {
        // TO DO SEND TO BUGSNAG
        console.error(error);
      }
    });
    return _deleteUserHighlight.apply(this, arguments);
  }
  function openAnnotationsPopover(contents) {
    var epubRect = document.getElementsByClassName('epub-view')[0].getBoundingClientRect();
    var contentRect = contents.window.getSelection().getRangeAt(0).getBoundingClientRect();
    var anchorPosition = {
      left: epubRect.left + contentRect.left,
      right: epubRect.left + contentRect.right,
      top: epubRect.top + contentRect.top,
      bottom: epubRect.top + contentRect.bottom
    };
    setAnchorPositionAnnotationPopover(anchorPosition);
  }
  function onClickHighlight(annotation) {
    setOpenDrawer(true);
    selectTab(1);
    setSelectedAnnotation(annotation);
  }
  function setHighlight(rendition, cfiRange, color) {
    // Timeout to handle Android issue
    rendition.annotations.highlight(cfiRange, {}, () => setTimeout(() => onClickHighlight({
      cfiRange
    }), 250), 'hl', {
      fill: color,
      'fill-opacity': '0.3',
      'mix-blend-mode': 'normal'
    });
  }
  function selectTextRange(rend, cfiRange) {
    var color = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _themes.DEFAULT_HIGHLIGHT_COLOR;
    var currentColor = color;

    // se é uma anotação que já existe, procura a cor correta
    var existingHighlight = highlightsState.filter(highlight => highlight.text_reference === cfiRange);
    if (existingHighlight && existingHighlight.length > 0) {
      currentColor = existingHighlight.color;
    }
    setHighlight(rend, cfiRange, _themes.READER_HIGHLIGHT_COLORS[currentColor]);
  }
  function onSelectHighlight(contents) {
    var _selection$toString;
    var selection = contents.window.getSelection();
    var isContentValid = selection === null || selection === void 0 || (_selection$toString = selection.toString()) === null || _selection$toString === void 0 || (_selection$toString = _selection$toString.trim()) === null || _selection$toString === void 0 ? void 0 : _selection$toString.replace(/\n/g, ' ');
    var isAppOffline = localStorage.getItem('isAppOffline');
    if (!isContentValid || isAppOffline) return;
    openAnnotationsPopover(contents);
    setIsDraft(true);
  }
  function updateHighlightColor(_x4, _x5) {
    return _updateHighlightColor.apply(this, arguments);
  }
  function _updateHighlightColor() {
    _updateHighlightColor = _asyncToGenerator(function* (highlight, color) {
      setHighlightColor(color);
      updateHighlight(highlight.id, {
        color
      });
      var newHighlight = _objectSpread(_objectSpread({}, highlight), {}, {
        color
      });
      replaceHighlightOnState(newHighlight);
      rendition.annotations.remove(highlight.textReference, 'highlight');
      setHighlight(rendition, highlight.textReference, _themes.READER_HIGHLIGHT_COLORS[color]);
    });
    return _updateHighlightColor.apply(this, arguments);
  }
  function deleteHighlight(_x6) {
    return _deleteHighlight.apply(this, arguments);
  }
  /* ------- Exported functions (through context) ------ */
  function _deleteHighlight() {
    _deleteHighlight = _asyncToGenerator(function* (highlight) {
      yield deleteUserHighlight(highlight.id);
      rendition.annotations.remove(highlight.textReference, 'highlight');
      trackingService.trackDeleteHighlight(_objectSpread(_objectSpread({}, highlight), {}, {
        uuid,
        titleCover: bookTitle
      }));
    });
    return _deleteHighlight.apply(this, arguments);
  }
  function setAndroidHighlightsCallback(reader) {
    var epubContainer = window.document.querySelector('.epub-container');
    var {
      document,
      contents
    } = reader;
    var {
      documentElement
    } = document;
    var contextMenuCallCount = 0;
    var noScrollLeft;
    documentElement.addEventListener('contextmenu', () => {
      contextMenuCallCount += 1;
      if (contextMenuCallCount > 1) {
        contextMenuCallCount = 0;
        setContents(contents);
        onSelectHighlight(contents);
        epubContainer.removeEventListener('scroll', noScrollLeft);
      } else {
        var {
          scrollLeft
        } = epubContainer;
        noScrollLeft = () => {
          epubContainer.scrollLeft = scrollLeft;
        };
        epubContainer.addEventListener('scroll', noScrollLeft);
      }
    });
  }
  function setHighlightsCallback() {
    var rend = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rendition;
    var reader = arguments.length > 1 ? arguments[1] : undefined;
    var mobileOS = (0, _utils.getMobileOperatingSystem)();
    var {
      document,
      contents
    } = reader;
    var {
      documentElement
    } = document;
    rend.on('selected', range => setCfiRange(range));
    if (mobileOS === 'Android') {
      setAndroidHighlightsCallback(reader);
    } else {
      documentElement.addEventListener('pointerup', () => {
        setContents(contents);
        onSelectHighlight(contents);
      });
    }

    // Cor exibida durante a seleção do texto
    rend.themes.default({
      '::selection': {
        background: 'rgba(129, 106, 177, 0.7)'
      }
    });
  }
  function updateHighlightAnnotation(_x7, _x8) {
    return _updateHighlightAnnotation.apply(this, arguments);
  }
  function _updateHighlightAnnotation() {
    _updateHighlightAnnotation = _asyncToGenerator(function* (highlightId, annotation) {
      var updatedHighlight = yield updateHighlight(highlightId, annotation);
      replaceHighlightOnState(updatedHighlight);
    });
    return _updateHighlightAnnotation.apply(this, arguments);
  }
  function updateColor(_x9, _x10) {
    return _updateColor.apply(this, arguments);
  }
  function _updateColor() {
    _updateColor = _asyncToGenerator(function* (highlight, color) {
      updateHighlightColor(highlight, color);
      yield trackingService.trackColorHighlightEdit({
        uuid,
        titleCover: bookTitle,
        color: highlight.color,
        id: highlight.id,
        highlight: highlight.textHighlighted
      });
    });
    return _updateColor.apply(this, arguments);
  }
  function handleCardColorClick(_x11) {
    return _handleCardColorClick.apply(this, arguments);
  }
  function _handleCardColorClick() {
    _handleCardColorClick = _asyncToGenerator(function* (color) {
      if (isDraft) {
        var _contents$window2;
        contents === null || contents === void 0 || (_contents$window2 = contents.window) === null || _contents$window2 === void 0 || (_contents$window2 = _contents$window2.getSelection()) === null || _contents$window2 === void 0 || _contents$window2.removeAllRanges();
        selectTextRange(rendition, cfiRange, color);
        yield saveHighlight(rendition, cfiRange, color);
        setIsDraft(false);
        setHighlightColor(color);
        return;
      }

      // checa se é o segundo clique, para excluir a anotação
      if (highlightColor === color) {
        setAnchorPositionAnnotationPopover();
        var lastHighlight = highlights.current[highlights.current.length - 1];
        deleteHighlight(lastHighlight);
        setHighlightColor();
        handleHighlightClose();
        return;
      }
      var highlight = highlights.current[highlights.current.length - 1];
      updateColor(highlight, color);
    });
    return _handleCardColorClick.apply(this, arguments);
  }
  function repaintHighlight(rendition) {
    var _window;
    if (!rendition || typeof rendition.views !== 'function') return;
    var safeRepaint = () => {
      var views = rendition.views();
      if (!Array.isArray(views)) return;
      views.forEach(view => {
        try {
          var pane = view === null || view === void 0 ? void 0 : view.pane;
          var canRender = pane && typeof pane.render === 'function';
          var hasElementReference = (pane === null || pane === void 0 ? void 0 : pane.element) || (view === null || view === void 0 ? void 0 : view.document) || (view === null || view === void 0 ? void 0 : view.container);
          if (!canRender || !hasElementReference) return;
          pane.render();
        } catch (error) {
          console.warn('Ignorando repaint de highlight em view não disponível:', error);
        }
      });
    };
    if (typeof ((_window = window) === null || _window === void 0 ? void 0 : _window.requestAnimationFrame) === 'function') {
      window.requestAnimationFrame(() => safeRepaint());
      return;
    }
    setTimeout(safeRepaint, 0);
  }
  return /*#__PURE__*/_react.default.createElement(HighlightsContext.Provider, {
    value: {
      highlights,
      highlightsState,
      setHighlights,
      setHighlightsCallback,
      selectTextRange,
      highlightColor,
      setHighlightColor,
      updateHighlightAnnotation,
      handleCardColorClick,
      deleteHighlight,
      anchorPositionAnnotationPopover,
      setAnchorPositionAnnotationPopover,
      repaintHighlight,
      handleHighlightClose,
      isDraft,
      contents,
      setContents,
      updateColor,
      setCfiRange
    }
  }, children);
};
exports.HighlightsProvider = HighlightsProvider;
HighlightsProvider.propTypes = {
  children: _propTypes.default.node.isRequired
};